module.exports = __webpack_public_path__ + "img/Weapon_228.f54563ca.png";